export default function OpenRehearsal () {

    return (
        <>
        <h1 class="h1 text-center w-11/12 m-auto pt-8 pb-12" id="subPageHeaderTitle">Open Rehearsal - 9/2/2026</h1>
            <div className='w-11/12 m-auto mt-0'>
                    <div className='pageSection'>
                        <p>VocaMotion is having an open rehearsal on September 2, 2026! Join us for a fun-filled night of singing, and learn what VocaMotion and our repertoire are about. 
                            No need to prepare anything-- just walk in as you are.
                            If you have any questions, or just want to tell us you are coming, please email membership@vocamotion.org or fill out the form on our About page. We hope to see you there!</p>
                        <br></br>
                        <p className='pb-1'><span className='underline'>Venue</span>:&nbsp; 
                             <a className='innerLink' 
                            href='https://maps.app.goo.gl/PaogPCY4oD5qdCsd6'>  
                                Follen Church, 755 Massachusetts Ave, Lexington, MA 02420</a>
                        </p>
                        <p className='pb-1'><span className='underline'>Date</span>: September 2, 2026</p>
                        <p className='pb-1'><span className='underline'>Time</span>: Rehearsal goes from 7pm-10pm. There is also an Afterglow (social hour, snacks) onsite directly following rehearsal, 10-11pm!</p>
                    </div> 
            </div>
        </>
    )
}